import React from 'react';
import { Button } from '../../ui/button';
import { Bike, Store } from 'lucide-react';
import { useSelector } from 'react-redux';
import { ROLES } from '../../../constants';
export const RelatedIssue = ({
  issue,
  selected,
  onClick,
}: {
  issue: any;
  selected: boolean;
  onClick: (_issueId: string) => void;
}) => {
  const role = useSelector((state: any) => state.auth.user.role);
  return (
    <Button
      size="sm"
      variant={selected ? 'default' : 'secondary'}
      className={`mr-2 ${selected ? 'cursor-default' : ''} mt-2 `}
      onClick={() => {
        !selected && onClick(issue);
      }}
    >
      {role === ROLES.ADMIN && issue.carrierId && <Bike />}
      {role === ROLES.ADMIN && issue.companyId && <Store />}
      <span className="w-[100px]">{issue.issueId}</span>
    </Button>
  );
};
